'use client';

import React, { useState, useEffect } from 'react';
import { Upload, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import { createClient } from '@/lib/supabase/client';

export default function ExportHeader() {
  const [readyCount, setReadyCount] = useState<number | null>(null);

  useEffect(() => {
    const load = async () => {
      const supabase = createClient();
      const { count } = await supabase?.from('reports')?.select('id', { count: 'exact', head: true });
      setReadyCount(count ?? 0);
    };
    load();
  }, []);

  return (
    <div className="flex items-start justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-green-950/40 border border-green-700/40 rounded flex items-center justify-center">
          <Upload size={20} className="text-green-400" />
        </div>
        <div>
          <p className="section-label mb-0.5">Veröffentlichung & Export</p>
          <h1 className="text-2xl font-800 text-white tracking-tight">Export & Sync</h1>
          <p className="text-sm text-muted mt-0.5">
            <span className="mono text-accent">
              {readyCount === null ? '…' : readyCount} Beiträge
            </span>{' '}
            bereit zum Export
          </p>
        </div>
      </div>
      <div className="flex gap-2">
        <button
          className="btn-ghost text-xs gap-2"
          onClick={() => toast?.info('Verbindungsstatus wird geprüft…')}
        >
          <RefreshCw size={13} />
          Status prüfen
        </button>
        <button
          className="btn-primary text-xs"
          onClick={() => toast?.success('Alle Kanäle synchronisiert')}
        >
          <Upload size={13} />
          Alles synchronisieren
        </button>
      </div>
    </div>
  );
}